import * as THREE from "three";
import {ManagerServerLeft} from "./ManagerServerLeft";
import {Line} from "../../Shapes/Line";
import {ManagerServerRight} from "./ManagerServerRight";
import {NetworkNode, RouterNetworkTree} from "../../../../../../../services/back/infrastructure-schema.service";
import {ManagerServerCenter} from "./ManagerServerCenter";
import {removeEmptyIntercoNetwork, separateNetworks} from "../NetworkSort";
import {IntercommunicationNetwork} from "../Networks/ManagerInterco";
import {RouterNodeOutput} from "../../System/GlobalSizing";

export function NetworkManager(
	scene: THREE.Scene,
	x: number,
	z: number,
	connectedNetworks: Array<NetworkNode>,
	i:number,
	dataguide: RouterNodeOutput[]
): void {
	// Vérification de la présence de Network autour du Router
	if (connectedNetworks.length > 0) {
		// Décomposition des Network d'intercommunication

		const separatedNetwork = separateNetworks(connectedNetworks);
		const newConnectedNetworks: Array<NetworkNode> = separatedNetwork.standardNetworks
		let intercoConnectedNetworks: Array<NetworkNode> = separatedNetwork.intercoNetworks

		intercoConnectedNetworks = removeEmptyIntercoNetwork(intercoConnectedNetworks)

		if (intercoConnectedNetworks.length > 0) {
			IntercommunicationNetwork(scene, x, z, dataguide[i].connectedIntercoNetwork, intercoConnectedNetworks);
		}

		const halfLength: number = newConnectedNetworks.length / 2;

		if (intercoConnectedNetworks.length === 0 && newConnectedNetworks.length % 2 != 0) {

			ManageAlone(scene, x, z, newConnectedNetworks)

		} else {

			if (newConnectedNetworks.length > 0) {
				ManagerRight(scene, x, z, newConnectedNetworks, 0)

				if (halfLength % 1 !== 0) {
					ManagerLeft(scene, x, z, newConnectedNetworks, halfLength + .5)
				} else {
					ManagerLeft(scene, x, z, newConnectedNetworks, halfLength)
				}
			}
		}
	}
}

function ManagerRight(
	scene: THREE.Scene,
	x: number,
	z: number,
	connectedNetworks: Array<NetworkNode>,
	i: number,
	backX: number = x,
): void {

	let newX: number = 0;

	if (i === 0) {
		ManagerServerRight(scene, x, z, connectedNetworks[i].network.servers.length, connectedNetworks[i].network.network.name, connectedNetworks[0].network.network.id, connectedNetworks[i].network.servers)

		const nbServers: number = connectedNetworks[i].network.servers.length;

		switch (nbServers) {
			case 0:
				newX = x + 8;
				backX = newX - 1;
				break
			case 1:
				newX = x + 8;
				backX = newX - 1;
				break
			case 2:
				newX = x + 12;
				backX = newX - 3;
				break
			case 3:
				newX = x + 16;
				backX = newX - 5;
				break
			default:
				newX = x + 20;
				backX = newX - 7;
				break
		}

		ManagerRight(scene, newX, z, connectedNetworks, i + 1, backX);

	} else if (i < connectedNetworks.length / 2) {

		Line(scene, x, z, backX, z)
		ManagerServerRight(scene, x, z, connectedNetworks[i].network.servers.length, connectedNetworks[i].network.network.name, connectedNetworks[i].network.network.id, connectedNetworks[i].network.servers)

		const nbServers: number = connectedNetworks[i].network.servers.length;

		switch (nbServers) {
			case 0:
				newX = x + 8;
				backX = newX - 1;
				break
			case 1:
				newX = x + 8;
				backX = newX - 1;
				break
			case 2:
				newX = x + 12;
				backX = newX - 3;
				break
			case 3:
				newX = x + 16;
				backX = newX - 5;
				break
			default:
				newX = x + 20;
				backX = newX - 7;
				break
		}

		ManagerRight(scene, newX, z, connectedNetworks, i + 1, backX);
	}
}

function ManagerLeft(
	scene: THREE.Scene,
	x: number,
	z: number,
	connectedNetworks: Array<NetworkNode>,
	i: number,
	backX: number = x,
): void {

	let newX;

	if (i === connectedNetworks.length / 2) {

		ManagerServerLeft(scene, x, z, connectedNetworks[i].network.servers.length, connectedNetworks[i].network.network.name, connectedNetworks[i].network.network.id, connectedNetworks[i].network.servers)

		const nbServers: number = connectedNetworks[i].network.servers.length;

		switch (nbServers) {
			case 0:
				newX = x - 8;
				backX = newX + 1;
				break
			case 1:
				newX = x - 8;
				backX = newX + 1;
				break
			case 2:
				newX = x - 12;
				backX = newX + 3;
				break
			case 3:
				newX = x - 16;
				backX = newX + 5;
				break
			default:
				newX = x - 20;
				backX = newX + 7;
				break
		}

		ManagerLeft(scene, newX, z, connectedNetworks, i + 1, backX);

	} else if (i < connectedNetworks.length) {

		Line(scene, x, z, backX, z)
		ManagerServerLeft(scene, x, z, connectedNetworks[i].network.servers.length, connectedNetworks[i].network.network.name, connectedNetworks[i].network.network.id, connectedNetworks[i].network.servers)

		const nbServers: number = connectedNetworks[i].network.servers.length;

		switch (nbServers) {
			case 0:
				newX = x - 8;
				backX = newX + 1;
				break
			case 1:
				newX = x - 8;
				backX = newX + 1;
				break
			case 2:
				newX = x - 12;
				backX = newX + 3;
				break
			case 3:
				newX = x - 16;
				backX = newX + 5;
				break
			default:
				newX = x - 20;
				backX = newX + 7;
				break
		}
		ManagerLeft(scene, newX, z, connectedNetworks, i + 1, backX);
	}
}

function ManageAlone(
	scene: THREE.Scene,
	x: number,
	z: number,
	connectedNetworks: Array<NetworkNode>,
): void {
	ManagerServerCenter(scene, x, z, connectedNetworks[0].network.servers.length, connectedNetworks[0].network.network.name, connectedNetworks[0].network.network.id, connectedNetworks[0].network.servers)

	const halfLength: number = connectedNetworks.length / 2;

	if (connectedNetworks.length > 1) {

		let newX: number;
		const nbServers: number = connectedNetworks[0].network.servers.length;

		switch (nbServers) {
			case 0:
				newX = 0;
				break
			case 1:
				newX = 0;
				break
			case 2:
				newX = 2;
				break
			case 3:
				newX = 4;
				break
			default:
				newX = 6;
				break
		}
		Line(scene, x, z, x + newX, z)
		ManagerRight(scene, x + newX, z, connectedNetworks, 1)
		Line(scene, x, z, x - newX, z)
		ManagerLeft(scene, x - newX, z, connectedNetworks, halfLength + .5)
	}
}
